module.exports = __webpack_public_path__ + "img/AboutUs.f15ed2b.png";